import {ReactNode} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {CloseIconButton} from "../../../atoms/CloseIconButton";

interface ILeadModalWrapperProps {
    handleModalClose: () => void;
    title: string;
    children: ReactNode;
    titleClassName?: string;
    containerClassName?: string;
    innerContainerClassName?: string;
    testId?: string;
}

export const LeadFormModalWrapper = (props: ILeadModalWrapperProps) => {
    const {handleModalClose, title, children, titleClassName, containerClassName, innerContainerClassName, testId} = props;

    return (
        <div className={containerClassName ?? defaultContainerStyles} data-testid={testId}>
            <div className={innerContainerClassName ?? defaultInnerContainerStyles}>
                <CloseIconButton
                    className={closeButtonStyles}
                    onClick={() => handleModalClose()}
                    size="1.6"
                    dataTestId={OFFER_TEST_IDS.OFFER_VIEW.CLOSE_LEAD_FORM_BUTTON}
                />

                <Text variant="headline_4" as="p" mb={3} className={titleClassName ?? defaultTitleStyles}>
                    {title}
                </Text>

                {children}
            </div>
        </div>
    );
};

const defaultContainerStyles = css({
    w: "100%",
    h: "100%",
    overflowY: "auto",
    md: {
        maxW: "544px",
        h: "auto",
        overflow: "visible"
    }
});

const defaultInnerContainerStyles = css({
    p: 3
});

const defaultTitleStyles = css({
    textAlign: "center"
});

const closeButtonStyles = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    boxShadow: "var(--shadow-2)",
    background: "white",
    width: "3.2rem",
    height: "3.2rem",
    zIndex: 11
});
import {ReactNode} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {CloseIconButton} from "../../../atoms/CloseIconButton";

interface ILeadModalWrapperProps {
    handleModalClose: () => void;
    title: string;
    children: ReactNode;
    titleClassName?: string;
    containerClassName?: string;
    innerContainerClassName?: string;
    testId?: string;
}

export const LeadFormModalWrapper = (props: ILeadModalWrapperProps) => {
    const {handleModalClose, title, children, titleClassName, containerClassName, innerContainerClassName, testId} = props;

    return (
        <div className={containerClassName ?? defaultContainerStyles} data-testid={testId}>
            <div className={innerContainerClassName ?? defaultInnerContainerStyles}>
                <CloseIconButton
                    className={closeButtonStyles}
                    onClick={() => handleModalClose()}
                    size="1.6"
                    dataTestId={OFFER_TEST_IDS.OFFER_VIEW.CLOSE_LEAD_FORM_BUTTON}
                />

                <Text variant="headline_4" as="p" mb={3} className={titleClassName ?? defaultTitleStyles}>
                    {title}
                </Text>

                {children}
            </div>
        </div>
    );
};

const defaultContainerStyles = css({
    w: "100%",
    h: "100%",
    overflowY: "auto",
    md: {
        maxW: "544px",
        h: "auto",
        overflow: "visible"
    }
});

const defaultInnerContainerStyles = css({
    p: 3
});

const defaultTitleStyles = css({
    textAlign: "center"
});

const closeButtonStyles = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    boxShadow: "var(--shadow-2)",
    background: "white",
    width: "3.2rem",
    height: "3.2rem",
    zIndex: 11
});
